import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import TwoFactorSetupPage from './pages/TwoFactorSetupPage';
import ReceiptsPage from './pages/ReceiptsPage';
import ReceiptDetailPage from './pages/ReceiptDetailPage';
import UploadPage from './pages/UploadPage';
import CategoryTrendsPage from './pages/CategoryTrendsPage';
import StoreComparisonPage from './pages/StoreComparisonPage';
import InflationPage from './pages/InflationPage';
import StoresPage from './pages/StoresPage';
import AccountSecurityPage from './pages/AccountSecurityPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import AdminUsersPage from './pages/AdminUsersPage';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isAdmin) return <Navigate to="/receipts" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      {/* No RequireAuth here — reached both by a logged-in user opting into
          2FA and by a just-authenticated-but-sessionless user completing an
          admin-forced setup (via tempToken router state). See the page. */}
      <Route path="/account/security/setup" element={<TwoFactorSetupPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/receipts" replace />} />
        <Route path="receipts" element={<ReceiptsPage />} />
        <Route path="receipts/:id" element={<ReceiptDetailPage />} />
        <Route path="upload" element={<UploadPage />} />
        <Route path="trends" element={<CategoryTrendsPage />} />
        <Route path="compare" element={<StoreComparisonPage />} />
        <Route path="inflation" element={<InflationPage />} />
        <Route path="stores" element={<StoresPage />} />
        <Route path="account/security" element={<AccountSecurityPage />} />
        <Route path="admin/settings" element={<RequireAdmin><AdminSettingsPage /></RequireAdmin>} />
        <Route path="admin/users" element={<RequireAdmin><AdminUsersPage /></RequireAdmin>} />
      </Route>
    </Routes>
  );
}
